import styled from 'styled-components';
import { CustomLink } from '@/components/CustomLink/CustomLink';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const ProfileMenuContent = styled.div`
  position: relative;
  width: 300px;
  padding: 20px 10px;
  background: ${({ theme }) => theme.palette.primary.background};
  border-radius: 14px;
  z-index: 9;
`;

export const ProfileInfoContainer = styled(CustomLink)`
  display: inline-flex;
  align-items: center;
  gap: 15px;
  padding: 0 10px 10px;
  user-select: none;
  color: ${({ theme }) => theme.palette.primary.labels};
  transition: color 0.1s linear;

  &:hover * {
    color: ${({ theme }) => theme.palette.brand.main};
  }
`;

export const ProfileInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ProfilePhoneNumber = styled(Typography.Numbers).attrs({
  $variant: '4',
})`
  line-height: 19.5px;
`;

export const ProfileNumber = styled(Typography.Text)`
  font-size: 13px;
  line-height: 16px;
`;

export const ProfileMenuItemsList = styled.ul``;

export const ProfileMenuItem = styled.li`
  display: flex;
  align-items: center;
  height: 52px;
  padding: 0 10px;
  color: ${({ theme }) => theme.palette.primary.labels};

  &:last-child {
    height: 53px;
    border-top: 1px solid ${({ theme }) => theme.palette.secondary.border};
  }

  & > a {
    width: 100%;
    padding: 7px 0;

    &:hover {
      color: ${({ theme }) => theme.palette.brand.main};
    }
  }
`;

export const ProfileMenuItemText = styled(Typography.Body)`
  color: inherit;
`;
